import Shop from './Shop';
export default function Lavapavimenti() {
  return <Shop defaultCategory="lavapavimenti" title="Lavapavimenti profumati ESSENYA" description="Formule pensate per pulire i pavimenti e diffondere negli ambienti una profumazione elegante, fresca e piacevole." />;
}
